import {
  MANAGEMENTS_REGISTER_TYPE_CLAIMS,
  SERVICES_SUBTYPE_OPTIMIZE_BILLS,
  SERVICES_SUBTYPE_OPTIMIZE_COVERAGES,
  SERVICES_SUBTYPE_OPTIMIZE_GAS,
  SERVICES_SUBTYPE_OPTIMIZE_POWER,
  RECIPIENT_IDS,
  RECIPIENT_IDS_TPI,
} from "../../../core/constants/constants";

const getServiceTypeId = (envirorment: string): number => {
  if (envirorment === "Luz") {
    return 8;
  }
  return 7;
};

const getServiceSubTypeId = (serviceTypeId: number, type: string): number => {
  const isLight = serviceTypeId === 8;

  switch (type) {
    case SERVICES_SUBTYPE_OPTIMIZE_POWER:
      return isLight ? 250 : 0;
    case SERVICES_SUBTYPE_OPTIMIZE_BILLS:
      return isLight ? 253 : 258;
    case SERVICES_SUBTYPE_OPTIMIZE_GAS:
      return isLight ? 0 : 255;
    case SERVICES_SUBTYPE_OPTIMIZE_COVERAGES:
      return isLight ? 252 : 0;
    default:
      return 0;
  }
};

const getRecipientId = (
  idTipoRegistro: number,
  idSubTipoRegistro: number,
  isAgent: boolean | null = false
): number | null => {
  if (isAgent) {
    const recipientTPI = RECIPIENT_IDS_TPI.find(
      (recipient) =>
        recipient.idTipoRegistro === idTipoRegistro &&
        recipient.idSubtipoReclamacion === idSubTipoRegistro
    );

    if (recipientTPI) {
      return recipientTPI.idUsuarioDestino;
    }
  }

  const recipient = RECIPIENT_IDS.find(
    (recipient) =>
      recipient.idTipoRegistro === idTipoRegistro &&
      recipient.idSubtipoReclamacion === idSubTipoRegistro
  );

  return recipient ? recipient.idUsuarioDestino : null;
};

const getServicesCodeTextIcon = (
  claimTextSubType: string
): { icon: string; text: string } => {
  switch (claimTextSubType) {
    case SERVICES_SUBTYPE_OPTIMIZE_POWER:
      return {
        icon: "t-icon-electricite-big",
        text: "Optimizador de potencias",
      };
    case SERVICES_SUBTYPE_OPTIMIZE_BILLS:
      return { icon: "t-icon-chart-bar", text: "Simulador de facturas" };
    case SERVICES_SUBTYPE_OPTIMIZE_GAS:
      return { icon: "t-icon-gaz-big", text: "Optimizador de caudal" };
    case SERVICES_SUBTYPE_OPTIMIZE_COVERAGES:
      return { icon: "t-icon-Bank", text: "Realizar coberturas" };
    default:
      return { icon: "", text: "" };
  }
};

const getServiceTitleText = (
  recordTextType: string,
  claimTextSubType: string
) =>
  recordTextType === MANAGEMENTS_REGISTER_TYPE_CLAIMS
    ? recordTextType
    : getServicesCodeTextIcon(claimTextSubType).text;

export {
  getServiceTypeId,
  getServiceSubTypeId,
  getServicesCodeTextIcon,
  getServiceTitleText,
  getRecipientId,
};
